import { createFileRoute } from "@tanstack/react-router";
import AdminPartsNews from "@/pages/admin/AdminPartsNews";

export const Route = createFileRoute("/_adminLayout/admin/parts/news/")({
  component: AdminPartsNews,
});